import React from 'react';
import 'falling-emojis/dist/index.css';
var styles = {
  "FallingEmojis": "_Jiv79",
  "emoji": "_1PZEU",
  "emojiAnimation0": "_8xRe2",
  "float": "_3oO7A",
  "emojiAnimation1": "_3xOMG",
  "emojiAnimation2": "_lA6Ei",
  "emojiAnimation3": "_2fsNE",
  "emojiAnimation4": "_2q_6E"
};

var FallingEmojis = function FallingEmojis(_ref) {
  var emoji = _ref.emoji;
  var emojiArray = [emoji, emoji, emoji, emoji, emoji];
  var order = [0, 3, 1, 2, 4];
  var animations = [styles.emojiAnimation0, styles.emojiAnimation1, styles.emojiAnimation2, styles.emojiAnimation3, styles.emojiAnimation4];
  return /*#__PURE__*/React.createElement("div", {
    className: styles.FallingEmojis
  }, emojiArray.map(function (emojiElement, i) {
    return /*#__PURE__*/React.createElement("span", {
      key: i,
      className: [styles.emoji, animations[order[i]]].join(' ')
    }, emojiElement);
  }));
};

export { FallingEmojis };